import { useLocation } from 'react-router-dom';

function useIsAdminPage() {
  const location = useLocation();
  const isAdmin = location.pathname.includes('admin');
  return isAdmin;
}

export default useIsAdminPage;
